import BaseModel from "./_BaseModel";

export default class GrupBarang extends BaseModel {
    public readonly ucode?: string;
    public kode?: string;
    public nama?: string;
    public is_jasa?: boolean = false;
    public is_sub_brg?: boolean = false;
    public is_sub_jasa?: boolean = false;
    public aktif?: boolean = true;
	public keterangan?: string;

    public constructor(
        ucode?: string
    ) {
        super();
        this.ucode = ucode;
    }
}